import { render } from "./BannedUsersList.vue?vue&type=template&id=b87e4ea8&scoped=true"
import script from "./BannedUsersList.vue?vue&type=script&lang=js"
export * from "./BannedUsersList.vue?vue&type=script&lang=js"

import "./BannedUsersList.vue?vue&type=style&index=0&id=b87e4ea8&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87e4ea8"]])

export default __exports__